PF.Entity.Set = class EntitySet extends Set
	{
	toJSON()
		{
		let jsonArray = [];
		for (let item of this)
			{
			jsonArray.push(item.toJSON());
			}
		return jsonArray;
		}
	};


